<template>
  <div class="mains">
    <div class="campus">
      教材管理
      <span>></span>
      <router-link to="selfbook">自制教材区</router-link>
      <span>></span>
      <span @click="tiaozhuan_danyuan">编辑课本</span>
      <span>></span>
      <span @click="tiaozhuan_danyuan1">编辑单元</span>
      <span>></span>
      编辑章节
    </div>
    <div class="xiaoqu">
      <el-card :span="24">
        <div class="xiaoqu_1">编辑章节</div>
        <div class="shenzhong">
          <i class="img_1"> <img src="@/assets/img/education-manage/campus/shenzhong.png" alt /> </i>
          自制课本分为"保存课本"与"发布课本"两种选择，保存课本是将自制的课本保存且存档，发布课本是将自制的课本发布至小程序端。
        </div>
        <div class="form_1 right kbfm">
          <el-form
            ref="forms"
            :model="form"
            :rules="FormRules"
            label-width="5.20833vw"
          >
            <el-form-item label="章节名称" prop="name">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <el-input
                v-model="form.name"
                placeholder="请输入课本名称 ( 可填写中英文，不超过15个字 )"
                disabled
              ></el-input>
            </el-form-item>

            <el-form-item
              label="板块框架"
              class="shangchuan_bg1"
              prop="orgcode"
            >
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <el-input
                v-model="orgcode"
                placeholder="请输入您新建的页面名称"
                @keyup.enter.native="addBookPageFromChapter"
              ></el-input>
              <div class="shangchuan_yinyue">
                <el-button class="daoru_btn" @click="addBookPageFromChapter">
                  新建 Page
                </el-button>
              </div>
            </el-form-item>

            <el-form-item label prop="orgcode" class="shangchuan_bg">
              <div class="grid-content">
                <div class="zsbg weijuchang">
                  <el-table :data="tableData" border style="width: 62.8125vw">
                    <el-table-column
                      prop="title"
                      label="章节及页面名称"
                      max-width="360"
                    >
                      <template slot-scope="scope1">
                        <!-- {{ scope1.row }} -->
                        <input
                          type="text"
                          class="yp_name"
                          :class="scope1.row.selected ? 'yp_name2' : 'yp_name1'"
                          v-model="scope1.row.title"
                          :disabled="scope1.row.selected"
                          :id="scope1.row.selected ? '' : 'inputId'"
                          @blur="blur1(scope1.$index, tableData)"
                          @keyup.13="blur1(scope1.$index, tableData)"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column label="章节排序">
                      <template slot-scope="scopes">
                        <el-input
                          v-model="scopes.row.seqnum"
                          class="yp_paixu"
                          @blur="blur1(scopes.$index, tableData)"
                          @keyup.enter.native="
                            $event.target.blur(scopes.$index, tableData)
                          "
                        ></el-input>
                      </template>
                    </el-table-column>

                    <el-table-column label="操作">
                      <template slot-scope="stData">
                        <el-button
                          type="text"
                          @click="chong(stData.$index, tableData)"
                        >
                          重命名
                        </el-button>
                        <el-button
                          type="text"
                          @click="bianji_tiaozhuan(stData.row.id)"
                        >
                          编辑页面
                        </el-button>
                        <el-button
                          type="text"
                          @click="deleteBookChapter(stData.row.id)"
                        >
                          删除页面
                        </el-button>
                        <!-- <el-button type="text" @click="zhizuo_py(stData.row)">
                          添加课件
                        </el-button> -->
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>

export default {
  name: 'addBookPageFromChapter',
  data () {
    return {
      form: {
        name: ''
      },
      FormRules: {},
      orgcode: '',
      tableData: [],
      addbookId: '',
      UnitIds: '',
      Chapter: '',
      bj_zz: false
    }
  },
  created () {
    if (!this.$store.state.Chapter) {
      this.$router.push({ name: 'addBookChapter' })
      return this.$message.error('您当前的章节数据获取失败！')
    }

    this.Chapter = this.$store.state.Chapter
    this.UnitIds = this.$store.state.UnitIds
    this.addbookId = this.$store.state.addbookIdss
    // console.log(this.addbookId)

    this.getBookPageById()
    this.getBookPageListFromChapter()
  },
  destroyed () {
    localStorage.removeItem('UnitIds')
    localStorage.removeItem('addbookIdss')
    localStorage.removeItem('Chapter')
  },
  watch: {
  },
  methods: {
    tiaozhuan_danyuan () {
      this.$store.commit('addbookId', this.addbookId)
      this.$router.push({ name: 'addBook' })
    },
    tiaozhuan_danyuan1 () {
      this.$store.commit('UnitId', this.UnitIds)
      this.$store.commit('addbookIdsss', this.addbookId)
      this.$router.push({ name: 'addBookChapter' })
    },

    bianji_tiaozhuan (Chapter) {
      this.$store.commit('Chapters', Chapter)
      this.$store.commit('Chapterss', this.Chapter)
      this.$store.commit('UnitIdss', this.UnitIds)
      this.$store.commit('addbookIdss1', this.addbookId)
      this.$router.push({ name: 'addBookPageArea' })
    },

    // 重命名
    chong (index, rows) {
      // console.log(index)
      // console.log(rows[index])
      rows[index].selected = false
      document.getElementById('inputId').focus()
      // this.$refs.id.focus()
    },

    blur1 (index, rows) {
      // console.log(rows[index])
      rows[index].selected = true

      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '')
      // let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/edu/bookpage/updateBookPage',
        method: 'POST',
        data: {
          id: rows[index].id,
          title: rows[index].title,
          seqnum: rows[index].seqnum
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      })
      pro
        .then(result => {
          // console.log(result)
          if (result.data.code === 0) {
            this.getBookPageListFromChapter()
            return this.$message.success('页面修改成功！')
          } else { return this.$message.error(result.data.message) }
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('页面修改失败：' + err)
        })
    },

    // 查询页面列表
    getBookPageListFromChapter () {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '')
      let pro = this.$http({
        url: '/edu/bookpage/getBookPageListFromChapter/' + this.Chapter,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token
        }
      })
      pro.then(result => {
        // console.log(result)
        if (result.data.code === 0) {
          this.tableData = result.data.data
          for (var i = 0; i < this.tableData.length; i++) {
            this.tableData[i].selected = true
          }
        } else { return this.$message.error(result.data.message) }
      })
        .catch(err => {
          // console.log('error===============')
          this.$message.error('查询页面列表失败：' + err)
        })
    },

    // 新增页面
    addBookPageFromChapter () {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '')
      if (this.orgcode === '') {
        return this.$message.error('请输入页面的名称！')
      }
      let pro = this.$http({
        url: '/edu/bookpage/addBookPageFromChapter',
        method: 'POST',
        data: {
          relid: this.Chapter,
          title: this.orgcode,
          seqnum: ''
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      })
      pro.then(result => {
        // console.log(result)
        if (result.data.code === 0) {
          this.getBookPageListFromChapter()
          this.orgcode = ''
        } else { return this.$message.error(result.data.message) }
      })
        .catch(err => {
          // console.log('error===============')
          this.$message.error('新增页面失败：' + err)
        })
    },

    // 删除章节
    deleteBookChapter (id) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '')
      this.$confirm('确认要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // axios请求服务器端实现删除
        let pro = this.$http({
          url: '/edu/bookpage/deleteBookPage/' + id,
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + token
          }
        })
        pro
          .then(result => {
            // console.log(result)
            if (result.data.code === 0) {
              this.getBookPageListFromChapter()
              return this.$message.success('删除章节成功!')
            } else { return this.$message.error(result.data.message) }
          })
          .catch(err => {
            // console.log(err)
            return this.$message.error('删除章节失败：' + err)
          })
      })
    },

    // ID 查询章节
    getBookPageById () {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '')
      let pro = this.$http({
        url: '/edu/bookunit/getBookBookChapterById/' + this.Chapter,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token
        }
      })
      pro
        .then(result => {
          // console.log(result)
          if (result.data.code === 0) {
            this.form.name = result.data.data.title
          } else { return this.$message.error(result.data.message) }
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('查询章节名称失败：' + err)
        })
    }
  }
}
</script>

<style lang="less">
</style>
